import React, { useState } from 'react';
import IconCheck from '@/svgs/check.svg?react';
import Button from './Button';
import { useMessageProvider } from '@/Contexts/MessageProvider';
import { useMode } from '@/Contexts/ModeProvider';
import { Tooltip } from '@/Components/Tooltip';

export default function ApplySuggestion({
  code,
  file,
}: {
  code: string;
  file: App.Data.FileData;
}) {
  const { sendDirect } = useMessageProvider();
  const [loading, setLoading] = useState(false);
  const { mode } = useMode();

  function handleApplySuggestionClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    setLoading(true);
    sendDirect({
      message: `Apply this code to mine:\n${code}`,
      classification: 2,
      file: file.id,
      mode: mode?.id,
    });
  }

  return (
    <Tooltip message="Apply Suggestion">
      <Button onClick={handleApplySuggestionClick} pending={loading}>
        <IconCheck className="h-4 w-4" />
      </Button>
    </Tooltip>
  );
}
